import { AvatarCharecter, AvatarImage, InputMentions, Pagination } from 'components';
import { useComment, useUser } from 'hooks'
import React, { useState } from 'react'
import { formatBytes, getMentionText, repareStorageURL, repareURL } from 'utils';
import { formatTimeAgo } from 'utils/time_helpers';
import Zoom from 'react-medium-image-zoom';

export default function Comments({ projectId, taskId }) {
    const { fetchData, createComment } = useComment();
    const { defaultProject } = useUser();
    const [currentPage, setCurrentPage] = useState(1);
    const [isFetch, setIsFetch] = useState(1);
    const { data } = fetchData(projectId, taskId, currentPage, isFetch)
    console.log("🚀 ~ Comments ~ data:", data, defaultProject);

    const handleSubmit = (payload, cb) => {
        createComment.mutate({ ...payload, project_id: projectId, commentable_type: 'task', commentable_id: taskId }, {
            onSuccess: () => { cb?.(); setIsFetch(s => ++s) }
        })
    }

    return (
        <div>
            <h4 className="font-medium text-gray-900 mb-2">Bình luận</h4>
            {/* Add Comment */}
            {/* <StyledMentionTextarea /> */}
            <InputMentions members={defaultProject?.members ?? []} onSubmit={handleSubmit} />
            <div className="space-y-4 my-4">
                {data?.data && data?.data.map((cmt, i) => <div key={`comment-${i}`} className="flex space-x-3">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm">
                        {cmt.creator_user?.avatar ?
                            <img className="w-8 h-8  rounded-full" src={repareURL(cmt.creator_user?.avatar)} alt={cmt.creator_user?.name} /> :
                            <AvatarCharecter className="w-8 h-8" name={cmt.creator_user?.name} />
                        }
                    </div>
                    <div className="flex-1">
                        <div className="flex items-center space-x-2 mb-1">
                            <span className="text-sm font-medium text-gray-900">{cmt.creator_user?.name}</span>
                            <span className="text-xs text-gray-500">{formatTimeAgo(cmt.created_at)}</span>
                            {/*  */}
                        </div>
                        <p className="text-sm text-gray-700">
                            {getMentionText(cmt?.content, defaultProject?.members)}
                        </p>
                        <div className="flex flex-col items-start space-x-2 mt-4 ">
                            <div className="space-y-2">
                                {cmt.files.map(file => <div key={file.id} className="flex gap-2 items-center">
                                    <Zoom>
                                        <img className="max-w-10 p-1 rounded-md border border-gray-300" src={repareStorageURL(`${file?.path}`)} alt={file.name} />
                                    </Zoom>
                                    <div className="flex flex-col justify-center">
                                        <p className="text-sm font-medium text-gray-900">{file.name}</p>
                                        <p className="text-xs text-gray-500">{formatBytes(file.size)}</p>
                                    </div>
                                </div>)}
                            </div>
                        </div>
                    </div>

                </div>)}
                {data?.totalPage > 1 && <div className='py-4'>
                    <Pagination currentPage={currentPage} totalPages={data?.totalPage || 1} onPageChange={p => setCurrentPage(p)} />
                </div>}
            </div>

        </div>
    )
}
